<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item
                label="巡更人名称"
                prop="name"
                label-width="100px"
                style="width: 80%"
              >
                <el-select clearable filterable v-model="searchForm.manageUserId"  placeholder="请选择巡更人员">
                  <el-option
                    v-for="item in personList"
                    :key="item.id"
                    :label="item.userName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="巡更点名称"
                prop="name"
                label-width="100px"
                style="width: 80%"
              >
                <el-select clearable filterable v-model="searchForm.patrolPointId"  placeholder="请选择巡更点">
                  <el-option
                    v-for="item in nightPatrolList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>    
            <el-col :span="6">
              <el-form-item
                label="巡更日期"
                prop="patrolTime"
                label-width="100px"
                style="width: 80%"
              >
                <el-date-picker
                  v-model="searchForm.patrolTime"
                  type="datetime"
                  placeholder="选择巡更日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
        <el-button
          size="small"
          type="primary"
          style="width: 90px; margin-right: 15px;margin-bottom:15px;"
          icon="el-icon-download"
          @click="downloadUrl"
        >
          导出</el-button
        >      
      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      > <el-table-column prop="name" label="巡更人" align="center">
        </el-table-column>
        <el-table-column prop="phone" label="手机号码" align="center">
        </el-table-column>
        <el-table-column prop="patrolCompleteTime" label="巡更日期" align="center">
        </el-table-column>
        <el-table-column prop="patrolPointName" label="巡更点" align="center">
        </el-table-column>
        <el-table-column prop="isAbnormal" label="是否异常" align="center" :formatter="isAbnormalList">
        </el-table-column>        
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >巡更详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          label-position="center"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="巡更人名称"
                prop="name"
                label-width="100px"
              >
                <el-input
                  v-model="addData.name"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="手机号码"
                prop="phone"
                label-width="100px"
              >
                <el-input
                  v-model="addData.phone"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>        
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="巡更日期"
                prop="patrolCompleteTime"
                label-width="100px"
              >
                <el-input
                  v-model="addData.patrolCompleteTime"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="巡更点名称"
                prop="patrolPointName"
                label-width="100px"
              >
                <el-input
                  v-model="addData.patrolPointName"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
         <el-row>
            <el-col :span="24">
              <el-form-item
                label="巡更图片"
                prop="img"
                label-width="100px"
              >
               <img :src="item" @click="seeImg(item)" alt="" v-for="(item,ind) in addData.img && addData.img.split(',')" :key="ind" width="70px" height="70px" style="margin-right:10px;cursor: pointer;">
              </el-form-item>
            </el-col>
          </el-row>   
            <el-row>
            <el-col :span="24">
              <el-form-item
                label="巡更详情"
                prop="content"
                label-width="100px"
              >
              <el-input
                type="textarea"
                autosize
                placeholder="无"
                disabled
                v-model="addData.content">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>        
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
        <el-dialog :visible.sync="dialogVisible" style="z-index: 1999">
        <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
  </div>
</template>

<script>
import reg from '@/utils/reg'
export default {
  data() {
    return {
      searchForm: {
        manageUserId: "",
        patrolTime: "",
        patrolPointId:""
      },
      checkedStr: [], //选中的名称
      checkedIds: [], //选中的id
      isShowTrue: false, //是否显示二级树
      dialogVisible:false,
      dialogImageUrl:'',
      defaultProps: {
        children: "children",
        value: "id",
        label: "name",
      },
      houseFlag: true,
      modalTitle: "巡更详情",
      props: {
        multiple: true,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      nightPatrolList:[
      ],
      addData: {
        id: "",
        name: "",
        time:''
      },
      patrolClass:[],
      personList:[],
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
      baseUrL:"https://szwy.zjwsrc.com/admin/patrol/list-export",
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    // 导出巡更记录
    downloadUrl(){
        var villageId = JSON.parse(localStorage.getItem('park_data')).id
        var {manageUserId,patrolPointId,patrolTime} = this.searchForm
        window.location.href = this.baseUrL + '?villageId=' + villageId + '&manageUserId=' + manageUserId + '&patrolPointId=' + patrolPointId + '&patrolTime=' + reg.filterTime(patrolTime); //文件路径

    },
    isAbnormalList(row){
      return row.isAbnormal == 1 ? '有异常' : '无异常'
    },
    // 查看图片
    seeImg(row){
        this.dialogImageUrl = row
        this.dialogVisible = true
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.isAddModal = true;
    },
    // 修改角色
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.isAddModal = true;
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.houseDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id: this.addData.id || "",
            name: this.addData.name.join(),
            time:reg.filterTime(this.addData.time)
          };
          return
          this.$Apis.houseAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad()
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
       this.onLoad()
    },
    onLoad(ind) {
      this.isShowloading = true;
      if(ind == 1){
        this.currentPage = 1
      }
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        manageUserId: this.searchForm.manageUserId,
        patrolTime:reg.filterTime(this.searchForm.patrolTime),
        patrolPointId:this.searchForm.patrolPointId,
        status:1
      };
      this.$Apis.manageTotalList().then((res) => {
        if (res.code == 200) {
          this.personList = res.data;
        }
      });        
      this.$Apis.patrolClassList().then((res) => {
        if (res.code == 200) {
          this.nightPatrolList = res.data.list;
        }
      });        
      this.$Apis.patrolList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item, ind) => {
            item.ind = ind + 1;
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>